import { FC } from 'react';
import { merge } from '../../utils/utility';
import { ImagePreloader } from '../image/ImagePreloader';

interface Props {
  src: string;
  className: string;
  animationIndex?: number;
  animationCount?: number;
}

const ANIMATION_TIME = 5;

export const BackgroundImage: FC<Props> = ({ src, className, animationIndex, animationCount }) => {
  let animationClass: string | undefined = undefined;

  switch (animationCount) {
    case 2:
      animationClass = 'animate-fade2';
      break;
    case 3:
      animationClass = 'animate-fade3';
      break;
    case 4:
      animationClass = 'animate-fade4';
      break;
    case 5:
      animationClass = 'animate-fade5';
      break;
    case 6:
      animationClass = 'animate-fade6';
      break;
    case 7:
      animationClass = 'animate-fade7';
      break;
    case 8:
      animationClass = 'animate-fade8';
      break;
    case 9:
      animationClass = 'animate-fade9';
      break;
    case 10:
      animationClass = 'animate-fade10';
      break;
  }
  return (
    <div
      className={merge(className, 'bg-cover bg-center', animationClass)}
      style={{
        backgroundImage: `url(${src})`,
        animationDelay: animationIndex ? `${animationIndex * ANIMATION_TIME}s` : undefined,
        zIndex: animationIndex !== undefined ? 99 - animationIndex : undefined,
        animationDuration: animationCount ? `${animationCount * ANIMATION_TIME}s` : undefined
      }}
    >
      <ImagePreloader url={src} />
    </div>
  );
};
